import { useEffect } from "react"
import { setBrands, setLoading } from "@/redux/slices/brandSlice"
import useBrands from "@/hooks/useBrands"
import { useAppDispatch } from "@/lib/hooks"

export function useInitBrands() {
  const dispatch = useAppDispatch()
  const { brands, isLoading } = useBrands()

  useEffect(() => {
    dispatch(setLoading(isLoading))
    if (brands?.length) {
      dispatch(setBrands(brands))
    }
  }, [brands, isLoading])
}
